export const level_profile = [
    { value: "junior", label: "junior" },
    { value: "mid", label: "mid" },
    { value: "senior",label: "senior" },
  ];